import configProvider from "config/configProvider";

// Height of the banner; the spacer below it reserves the same height so page content starts under it.
const BANNER_HEIGHT = 24;

/**
 * Environment banner ("QA - 20261021.1"), pinned to the top of every page.
 *
 * Shown only when ENVIRONMENT_BANNER is set on the web app (QA sets it; production does not), so
 * production renders nothing. The version is APP_VERSION, baked into the image at build time from
 * the Azure DevOps build number, so it always names the image actually running -- including after a
 * rollback or a redeploy of an older tag.
 */
export function bannerText(environment?: string, version?: string): string | null {
  const env = (environment ?? "").trim();
  if (!env) return null;
  const ver = (version ?? "").trim();
  return ver ? `${env} - ${ver}` : env;
}

export default function EnvironmentBanner() {
  const text = bannerText(configProvider?.ENVIRONMENT_BANNER, configProvider?.APP_VERSION);
  if (!text) return null;

  return (
    <>
      <div
        role="status"
        aria-label={`Environment: ${text}`}
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          height: BANNER_HEIGHT,
          lineHeight: `${BANNER_HEIGHT}px`,
          zIndex: 2000,
          background: "#d32f2f",
          color: "#ffffff",
          fontSize: 13,
          fontWeight: 700,
          letterSpacing: "0.05em",
          textAlign: "center",
          pointerEvents: "none",
        }}
      >
        {text}
      </div>
      <div style={{ height: BANNER_HEIGHT }} />
    </>
  );
}
